<script>
import i18n from '@/i18n/i18n';
export default {
	name: 'msBaseComponentDefault',
	i18n: i18n
};
</script>
<style lang="scss" scoped></style>
